module.exports = __webpack_public_path__ + "static/media/img_code_2.b8d116e1.png";